import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TimeOverviewBasePage } from './time-overview-base.page';

const routes: Routes = [
  {
    path: '',
    component: TimeOverviewBasePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TimeOverviewBasePageRoutingModule {}
